export default __webpack_public_path__ + "b7f45db728bfaa6a206c758670cee50a.svg";